const operators = ['>', '>=', '<', '<=', '=', '&&', '||', '!', '+', '-', '*', '/']

const invalidCharactersRegex = /[^a-zA-Z0-9><=&|!+\-*./]/g;

const alarmSituationInputFormulaConstants = {
    operators,
    invalidCharactersRegex
}


export default alarmSituationInputFormulaConstants